import React from 'react';
import cn from 'classnames';

import Image from 'next/image';

import Text from '@components/Text';
import Title from '@components/Title';

import { advatageArray } from '@modules/home/constants';

import s from './AdvantageBlock.module.scss';

interface Props {
  className?: string;
  bgColor?: 'white' | 'wheat';
}

const AdvantageBlock: React.FC<Props> = ({ className, bgColor }) => {
  const classes = cn(s.root, className);

  return (
    <div className={classes}>
      {advatageArray.map(({ id, title, text, imgLink, alt }) => (
        <div className={cn(s.block, !bgColor || bgColor === 'white' ? s.bgWhite : s.bgEcruWhite)} key={id}>
          <header className={s.blockHeader}>
            <span className={s.image}>
              <Image alt={alt} src={imgLink} layout="fill" objectFit="cover" />
            </span>
            <Title level={3} className={s.blockTitle}>
              <span dangerouslySetInnerHTML={{ __html: title || '-' }} />
            </Title>
          </header>
          <Text className={s.blockText}>
            <span dangerouslySetInnerHTML={{ __html: text || '-' }} />
          </Text>
        </div>
      ))}
    </div>
  );
};

export default AdvantageBlock;
